import { createContext, useContext } from 'react';
import {
  categoricalColor,
  DEFAULT_REPORT_COLOR_PALETTE,
  type ReportColorPaletteColors,
} from '@erp/shared-types';

/**
 * The color palette every component on a report canvas draws with. A surface
 * provides the one its Report resolves to (its own, else the organization's
 * default); without a provider, components draw with the built-in palette.
 * Any registered component type reads it here, so a new widget themes the
 * same way as the builtin charts.
 */
export const ReportColorPaletteContext =
  createContext<ReportColorPaletteColors>(DEFAULT_REPORT_COLOR_PALETTE);

export function useReportColors(): ReportColorPaletteColors {
  return useContext(ReportColorPaletteContext);
}

/** The color a single-series chart draws with: the palette's first. */
export function useSeriesColor(): string {
  return categoricalColor(useReportColors(), 0);
}
